import { Component, AfterViewInit, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from "jquery";
import { MenuService } from './menu.service';
import { Theme } from '../service/AutoTheme';
import decryptData from '../service/commonFunction';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { environment } from '../../../environments/environment';
import { getReportsMenuItem } from './report-sidebar.config';
@Component({
  selector: 'ap-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  showSubMenu: string = '';
  showMenu: string = '';
  public menu: any;
  public showMobileMenu = false;
  public sidebarnavItems: any[];
  //this is for the open close
  showHide: boolean = true;
  imgtoggle: boolean = false;
  // logo:any='./assets/images/icon/gventure.png'
  logo:any
  logo1:any

  constructor(private modalService: NgbModal, private router: Router, private route: ActivatedRoute, private data: MenuService, public theme: Theme) {
    let n_url = environment.cental_url
    this.data.getDetails(n_url).subscribe(res=>{
      console.log("side_logo",res.data[0].side_logo)
      this.logo = res.data[0].side_logo 
      this.logo1 = res.data[0].icon
  
    })
    
  }

 
  ngOnInit() {
    const keyobj = decryptData(sessionStorage.getItem('tokenauthkey'));
    if (keyobj == undefined) {
      this.router.navigate(["/login"]);
    }

    if (keyobj.type == '0') {
      this.sidebarnavItems = this.getAdminMenu();
    } else if (keyobj.type == '2') {
      this.sidebarnavItems = this.getSubAdminMenu();
    } else {
      this.sidebarnavItems = this.getCustomerMenu();
    }

    this.initActiveMenu(this.router.url);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.initActiveMenu(event.urlAfterRedirects);
      }
    });
  }

  /**
   * Automatically expands the Reports menu and the matching category when the
   * current URL belongs to the dialer-reports module.
   */
  private initActiveMenu(url: string) {
    if (!url.includes('dialer-reports')) { return; }

    const reportsItem = this.sidebarnavItems.find(i => i.title === 'Dialer Reports');
    if (!reportsItem) { return; }

    this.showMenu = reportsItem.title;

    for (const category of reportsItem.submenu) {
      const active = category.submenu.some((leaf: any) =>
        leaf.path && url.includes(leaf.path.split('?')[0])
      );
      if (active) {
        this.showSubMenu = category.title;
        return;
      }
    }
  }

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  changeShowStatus() {
    // this.showHide = this.showHide;
    this.imgtoggle = !this.imgtoggle;

  }

  // decryptData(data) {
  //     try {
  //         const bytes = CryptoJS.AES.decrypt(data, sessionStorage.getItem('token'));
  //         if (bytes.toString()) {
  //         return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  //         }
  //         return data;
  //     } catch (e) {
  //         console.error(e);
  //     }
  // }

  profile() {
    this.router.navigate(["main/profile/"]);
  }

  ngAfterViewInit() {
    $(function () {
      $(".sidebartoggler").on('click', function () {
        if ($("body").hasClass("mini-sidebar")) {
          $("body").trigger("resize");
          $(".scroll-sidebar, .slimScrollDiv").css("overflow", "hidden").parent().css("overflow", "visible");
          $("body").removeClass("mini-sidebar");
          $('.navbar-brand span').show();
          //$(".sidebartoggler i").addClass("ti-menu");
        }
        else {
          $("body").trigger("resize");
          $(".scroll-sidebar, .slimScrollDiv").css("overflow-x", "visible").parent().css("overflow", "visible");
          $("body").addClass("mini-sidebar");
          $('.navbar-brand span').hide();
          //$(".sidebartoggler i").removeClass("ti-menu");
        }
      });
    });
  }

  
  public getSubAdminMenu() {
    console.log(sessionStorage.getItem('is_package') == '1', sessionStorage.getItem('is_package'))
    console.log(sessionStorage.getItem('is_package') == '1')
    let menu: any = [
      {
        "path": "./dashboards/dashboard3",
        "title": "Home",
        "icon": "mdi mdi-home",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/usermanager",
        "title": "Account Management",
        "icon": "fas fa-users",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/packages",
        "title": "Packages",
        "icon": "mdi mdi-package",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/keyword",
        "title": "Keyword",
        "icon": "mdi mdi-pencil",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      }, 
      {
        "path": "./admin/supplier",
        "title": "Supplier",
        "icon": "fas fa-shopping-bag",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      // {
      //   "path": "./new-report",
      //   "title": "New Report",
      //   "icon": "fa fa-file-text-o",
      //   "class": "",
      //   "label": "",
      //   "labelClass": "",
      //   "extralink": false,
      //   "submenu": []
      // },



    ]
    // if(sessionStorage.getItem('is_package')=='1'){
    //   menu.push( {
    //     "path": "./admin/packages",
    //     "title": "Packages",
    //     "icon": "mdi mdi-package",
    //     "class": "",
    //     "label": "",
    //     "labelClass": "",
    //     "extralink": false,
    //     "submenu": []
    //   })
    // }
    // if(sessionStorage.getItem('is_supplier')=='1'){
    //   menu.push({
    //     "path": "./admin/supplier",
    //     "title": "Supplier",
    //     "icon": "fas fa-shopping-bag",
    //     "class": "",
    //     "label": "",
    //     "labelClass": "",
    //     "extralink": false,
    //     "submenu": []
    //   })
    // }
    // if(sessionStorage.getItem('is_server')=='1'){
    //   menu.push(       {
    //     "path": "./admin/server",
    //     "title": "Server",
    //     "icon": "mdi mdi-server",
    //     "class": "",
    //     "label": "",
    //     "labelClass": "",
    //     "extralink": false,
    //     "submenu": []
    //   })
    // }
    // if(sessionStorage.getItem('is_managment')=='1'){
    //   menu.push( {
    //     "path": "./admin/usermanager",
    //     "title": "Account Management",
    //     "icon": "fas fa-users",
    //     "class": "",
    //     "label": "",
    //     "labelClass": "",
    //     "extralink": false,
    //     "submenu": []
    //   })
    // }
    // if(sessionStorage.getItem('is_sampledata')=='1'){
    //   menu.push(  {
    //     "path": "sample",
    //     "title": "Sample data",
    //     "icon": "mdi mdi-file-document-box",
    //     "class": "has-arrow",
    //     "label": "",
    //     "labelClass": "",
    //     "extralink": false,
    //     "submenu": [
    //       {
    //         "path": "./lead",
    //         "title": "Lead",
    //         "icon": " fas fa-user-plus text-white",
    //         "class": "",
    //         "label": "",
    //         "labelClass": "",
    //         "extralink": false,
    //         "submenu": []
    //       },
    //       {
    //         "path": "./agent/agent",
    //         "title": "Agent",
    //         "icon": "flaticon2-user text-white",
    //         "class": "",
    //         "label": "",
    //         "labelClass": "",
    //         "extralink": false,
    //         "submenu": []
    //       },
    //       {
    //         "path": "./listdid",
    //         "title": "DID",
    //         "icon": "fa fa-book text-white",
    //         "class": "",
    //         "label": "",
    //         "labelClass": "",
    //         "extralink": false,
    //         "submenu": []
    //       },
    //       // {
    //       //   "path": "setting/crm",
    //       //   "title": "CRM Label",
    //       //   "icon": "fas fa-user-tag text-white",
    //       //   "class": "",
    //       //   "label": "",
    //       //   "labelClass": "",
    //       //   "extralink": false,
    //       //   "submenu": []
    //       // },
    //       {
    //         "path": "setting/audio",
    //         "title": "Audio",
    //         "icon": "fa fa-file-audio text-white",
    //         "class": "",
    //         "label": "",
    //         "labelClass": "",
    //         "extralink": false,
    //         "submenu": []
    //       }, 
    //       {
    //         "path": "./campaign/campaign",
    //         "title": "Campaign",
    //         "icon": "fab fa-joget text-white",
    //         "class": "",
    //         "label": "",
    //         "labelClass": "",
    //         "extralink": false,
    //         "submenu": []
    //       },
    //       // {
    //       //   "path": "reports",
    //       //   "title": "Reports",
    //       //   "icon": "fa fa-file-text-o",
    //       //   "class": "has-arrow",
    //       //   "label": "",
    //       //   "labelClass": "",
    //       //   "extralink": false,
    //       //   "submenu": [
    //       //     {
    //       //       "path": "reports/cdrreports",
    //       //       "title": "CDR",
    //       //       "icon": "fa fa-briefcase",
    //       //       "class": "",
    //       //       "label": "",
    //       //       "labelClass": "",
    //       //       "extralink": false,
    //       //       "submenu": []
    //       //     },
    //       //     {
    //       //       "path": "reports/campaignreports",
    //       //       "title": "Campaign",
    //       //       "icon": "fab fa-joget",
    //       //       "class": "",
    //       //       "label": "",
    //       //       "labelClass": "",
    //       //       "extralink": false,
    //       //       "submenu": []
    //       //     },
    //       //     {
    //       //       "path": "reports/currentcall",
    //       //       "title": "Current Calls",
    //       //       "icon": "fab fa-joget",
    //       //       "class": "",
    //       //       "label": "",
    //       //       "labelClass": "",
    //       //       "extralink": false,
    //       //       "submenu": []
    //       //     }
    //       //   ]

    //       // }
    //     ]
    //   })
    // }
    // if(sessionStorage.getItem('is_setting')=='1'){
    //   menu.push(   {
    //     "path": "setting",
    //     "title": "Setting",
    //     "icon": "mdi mdi-settings",
    //     "class": "has-arrow",
    //     "label": "",
    //     "labelClass": "",
    //     "extralink": false,
    //     "submenu": [
    //       {
    //         "path": "setting/crm",
    //         "title": "CRM Label",
    //         "icon": "fas fa-user-tag text-white",
    //         "class": "",
    //         "label": "",
    //         "labelClass": "",
    //         "extralink": false,
    //         "submenu": []
    //       }
    //     ]
    //   })
    // }
    console.log(menu)
    return menu
  }
  public getAdminMenu(): any {
    // return this.http.get('/assets/adminmenu.json');
    let menu: any = [
      {
        "path": "./dashboards/dashboard3",
        "title": "Home",
        "icon": "mdi mdi-home",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/usermanager",
        "title": "Account",
        "icon": "fas fa-users",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/usermanager/subadminmanager",
        "title": "Sub-Admin",
        "icon": "fi fi-ss-user-gear",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/packages",
        "title": "Packages",
        "icon": "mdi mdi-package",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/supplier",
        "title": "Supplier",
        "icon": "fas fa-shopping-bag",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/server",
        "title": "Server",
        "icon": "mdi mdi-server",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./admin/keyword/keyword-list",
        "title": "Keyword",
        "icon": "mdi mdi-pencil",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "sample",
        "title": "Sample data",
        "icon": "mdi mdi-file-document-box",
        "class": "has-arrow",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": [
          {
            "path": "./lead/leadsdata",
            "title": "Lead",
            "icon": " fas fa-user-plus text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "./agent/agentdata",
            "title": "Agent",
            "icon": "flaticon2-user text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "./listdid/diddata",
            "title": "DID",
            "icon": "fa fa-book text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },

          
          // {
          //   "path": "setting/crm",
          //   "title": "CRM Label",
          //   "icon": "fas fa-user-tag text-white",
          //   "class": "",
          //   "label": "",
          //   "labelClass": "",
          //   "extralink": false,
          //   "submenu": []
          // },
          {
            "path": "setting/audiio",
            "title": "Audio",
            "icon": "fa fa-file-audio text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "./campaigns/campaigndata",
            "title": "Campaign",
            "icon": "fab fa-joget text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          // {
          //   "path": "reports",
          //   "title": "Reports",
          //   "icon": "fa fa-file-text-o",
          //   "class": "has-arrow",
          //   "label": "",
          //   "labelClass": "",
          //   "extralink": false,
          //   "submenu": [
          //     {
          //       "path": "reports/cdrreports",
          //       "title": "CDR",
          //       "icon": "fa fa-briefcase",
          //       "class": "",
          //       "label": "",
          //       "labelClass": "",
          //       "extralink": false,
          //       "submenu": []
          //     },
          //     {
          //       "path": "reports/campaignreports",
          //       "title": "Campaign",
          //       "icon": "fab fa-joget",
          //       "class": "",
          //       "label": "",
          //       "labelClass": "",
          //       "extralink": false,
          //       "submenu": []
          //     },
          //     {
          //       "path": "reports/currentcall",
          //       "title": "Current Calls",
          //       "icon": "fab fa-joget",
          //       "class": "",
          //       "label": "",
          //       "labelClass": "",
          //       "extralink": false,
          //       "submenu": []
          //     }
          //   ]

          // }
        ]
      },
      {
        "path": "setting",
        "title": "Settings",
        "icon": "mdi mdi-settings",
        "class": "has-arrow",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": [
          {
            "path": "setting/crm",
            "title": "CRM Label",
            "icon": "fas fa-user-tag text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },     {
            "path": "setting/custom-report",
            "title": "Custom Reports",
            "icon": "fas fa-user-tag text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/customization",
            "title": "Customization",
            "icon": "fas fa-user-tag text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          }
        
        ]
      },         
      {
       "path": "transaction-details",
       "title": "Billing",
       "icon": "fas fa-money-bill",
       "class": "has-arrow",
       "label": "",
       "labelClass": "",
       "extralink": false,
       "submenu": [
         {
           "path": "setting/stripe",
           "title": "Stripe",
           "icon": "fas fa fa-cc-stripe",
           "class": "",
           "label": "",
           "labelClass": "",
           "extralink": false,
           "submenu": []
         },
         {
           "path": "setting/transaction-details",
           "title": "Transaction Details",
           "icon": "fi fi-ss-time-past",
           "class": "",
           "label": "",
           "labelClass": "",
           "extralink": false,
           "submenu": []
         }
       ]
     },
     // {
     //   "path": "./new-report",
     //   "title": "New Report",
     //   "icon": "fa fa-file-text-o",
     //   "class": "",
     //   "label": "",
     //   "labelClass": "",
     //   "extralink": false,
     //   "submenu": []
     // }
    ]
    return menu
  }
   removeDuplicates(arr, prop) {
    return arr.filter((obj, index, self) =>
        index === self.findIndex((t) => (
            t[prop] === obj[prop]
        ))
    );
}
 convertToUrlFormat(str) {
  return str.toLowerCase().replace(/\s+/g, '/');
}
  public getCustomerMenu(): any {
    let menu: any = [
      {
        "path": "./dashboards/dashboard3",
        "title": "Home",
        "icon": "mdi mdi-home icon-2x",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./campaign/campaign",
        "title": "Campaigns",
        "icon": "fab fa-joget",
        "class": "has-arrow",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": [
          {
            "path": "./campaigns/campaign",
            "title": "Campaign",
            "icon": "fab fa-joget text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/dnc",
            "title": "DNC",
            "icon": "fas fa-phone-slash text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/crm1",
            "title": "CRM Label",
            "icon": "fas fa-user-tag text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/audio",
            "title": "Audio",
            "icon": "fa fa-file-audio text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/ivr",
            "title": "IVR",
            "icon": "la la-headphones text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
        ]
      },
      {
        "path": "./agent/agent",
        "title": "Agents",
        "icon": "flaticon2-user",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./lead",
        "title": "Leads",
        "icon": " fas fa-user-plus",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./listdid",
        "title": "DIDs",
        "icon": "fa fa-book",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./calendar",
        "title": "Calendar",
        "icon": "fa fa-calendar",
        // "img": "assets/images/background/comingsoon.png",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      {
        "path": "./email-setting",
        "title": "Email",
        "icon": "mdi mdi-email",
        // "img": "assets/images/background/_alpha.png",
        "class": "",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": []
      },
      // {
      //   "path": "./automation",
      //   "title": "Automations",
      //   "icon": "fas fa-cogs",
      //   "img": "assets/images/background/comingsoon.png",
      //   "class": "has-arrow",
      //   "label": "",
      //   "labelClass": "",
      //   "extralink": false,
      //   "submenu": [
      //     {
      //       "path": "./automation",
      //       "title": "Automation",
      //       "icon": "fas fa-cogs text-white",
      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     },
      //     {
      //       "path": "setting/emailtemplate",
      //       "title": "Email",
      //       "icon": "fas fa-envelope text-white",

      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     },
      //     {
      //       "path": "setting/smstemplete",
      //       "title": "SMS",
      //       "icon": "fas fa-sms text-white",
      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     }
      //   ]

      // },
      {
        "path": "Script",
        "title": "Script",
        "icon": "mdi mdi-phone",
        "class": "has-arrow",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": [
          {
            "path": "setting/script",
            "title": "Phone Script",
            "icon": "fa fa-phone-square text-white",
            "class": "new_badge",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/sub-list",
            "title": "Sub Script",
            "icon": "fa fa-phone-square text-white",
            "class": "new_badge",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
        ]
      },
      {
        "path": "setting",
        "title": "Settings",
        "icon": "mdi mdi-settings",
        "class": "has-arrow",
        "label": "",
        "labelClass": "",
        "extralink": false,
        "submenu": [
          {
            "path": "setting/disposition",
            "title": "Disposition",
            "icon": "fas fa-project-diagram text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/skill",
            "title": "Skill",
            "icon": "fa fa-users text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/language",
            "title": "Language",
            "icon": "fa fa-language text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          // {
          //   "path": "setting/custom-report",
          //   "title": "Custom report",
          //   "icon": "fas fa-chart-bar text-white",
          //   "class": "",
          //   "label": "",
          //   "labelClass": "",
          //   "extralink": false,
          //   "submenu": []
          // },
          // {
          //   "path": "./avatar/avatar",
          //   "title": "Avatar",
          //   "icon": "flaticon2-user text-white",
          //   "img": "assets/images/background/comingsoon.png",
          //   "class": "new_badge",
          //   "label": "",
          //   "labelClass": "",
          //   "extralink": false,
          //   "submenu": []

          // },
          // {
          //   "path": "setting/script",
          //   "title": "Phone Script",
          //   "icon": "fa fa-phone-square text-white",
          //   "img": "assets/images/background/comingsoon.png ",
          //   "class": "new_badge",
          //   "label": "",
          //   "labelClass": "",
          //   "extralink": false,
          //   "submenu": []
          // },
          {
            "path": "setting/Apiconfiguration",
            "title": "API Configuration",
            "icon": "fas fa-file-export text-white",
            "img": "assets/images/background/comingsoon.png ",
            "class": "api_config",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          },
          {
            "path": "setting/webhook",
            "title": "Webhook",
            "icon": "fas fa-file-export text-white",
            "class": "",
            "label": "",
            "labelClass": "",
            "extralink": false,
            "submenu": []
          }
        ]
      },
      // {
      //   "path": "./report/summary",
      //   "title": "Reports",
      //   "icon": "fa fa-file-text-o",
      //   "class": "has-arrow",
      //   "label": "",
      //   "labelClass": "",
      //   "extralink": false,
      //   "submenu": [
      //     {
      //       "path": "report/summary/agent-activity-report/0",
      //       "title": "Agents",
      //       "icon": "fa fa-address-book text-white",
      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     },
      //     {
      //       "path": "report/summary/agent-activity-report/3",
      //       "title": "Call Center",
      //       "icon": "fa fa-headphones text-white",
      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     },
      //     {
      //       "path": "report/summary/agent-activity-report/1",
      //       "title": "Call Termination",
      //       "icon": "mdi mdi-phone-hangup text-white",
      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     },
      //     {
      //       "path": "report/summary/agent-activity-report/2",
      //       "title": "Live Calls",
      //       "icon": "flaticon2-group text-white",
      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     },
      //     {
      //       "path": "report/summary/agent-activity-report/4",
      //       "title": "Minute usage",
      //       "icon": "mdi mdi-call-made text-white",
      //       "class": "",
      //       "label": "",
      //       "labelClass": "",
      //       "extralink": false,
      //       "submenu": []
      //     }
      //   ]
      // },
      getReportsMenuItem(),
    ]

    return menu
  }

}